import { Component} from '@angular/core';
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { nav_path } from 'src/app/app-routing.module';
import { Category } from '../../../../shared/interfaces/category';
import { FirestoreService } from '../../../../shared/services/firestore.service';
import { MatDialog } from '@angular/material/dialog';
import { NewCategoryComponent } from './new-category/new-category.component';

@Component({
  selector: 'anon-admin-categories',
  templateUrl: './admin-categories.component.html',
  styleUrls: ['./admin-categories.component.scss']
})
export class AdminCategoriesComponent {
  categories$: Observable<Category[] | any>
  error: any;
  nav_path = nav_path;

  constructor(
    private db: FirestoreService,
    private dialog: MatDialog
  ) {
    this.categories$ = this.db.col$(`categories`)
      .pipe(catchError(error => {
      this.error = error;
      return throwError(error);
    }));
  }

  public openCategoryDialog() {
    this.dialog.open(NewCategoryComponent, {
      width: '800px',
      panelClass: 'new-category-dialog-container',
      id: 'new-category-dialog',
    });
  }

}
